import React, { useState, useEffect } from 'react';
import { TextField, Modal, Backdrop, Fade, makeStyles } from '@material-ui/core';
import fontFamily from '../../../assets/css/fonts';
import color from '../../../assets/css/colors';
import Button from '../../../components/Buttons/Button';
import CloseButton from '../../../components/Buttons/CloseButton';
import Text from '../../../components/Typography/Text';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 800,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
}));

export default function ExerciseDeclarationModal({
  onClose: handleClose,
  open: isOpen,
  value,
  loading: saving,
}) {
  const classes = useStyles();
  const [modalData, setModalData] = useState({});
  const [isEdit, setIsEdit] = React.useState(false);

  useEffect(() => {
    if (isOpen) {
      setModalData({ ...value });

      if ((value.dned && value.dned !== '0') || (value.eed && value.eed !== '0')) {
        setIsEdit(true);
      }
    }
  }, [isOpen, value]);

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setModalData({
      ...modalData,
      [input.name]: input.value,
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={isOpen}
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div style={{ width: 800 }}>
          <div className={classes.modalHeader}>
            <div>
              <Text
                mt={4}
                id="transition-modal-title"
                variant="h2"
                label={
                  isEdit ? 'Edit Exercise Declaration' : 'Add New Exercise Declaration'
                }
              />
            </div>
            <div className={classes.closeButton}>
              <CloseButton onClick={() => handleClose()} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <div className="grd-row nm">
              <div className="grd-cell">
                <TextField
                  fullWidth
                  disabled
                  label="Position Qty"
                  name="positionQty"
                  value={modalData.positionQty}
                  type="number"
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <TextField
                  fullWidth
                  label="EED Qty"
                  name="eed"
                  value={modalData.eed}
                  type="number"
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className="grd-cell">
                <TextField
                  fullWidth
                  label="DNED Qty"
                  name="dned"
                  value={modalData.dned}
                  type="number"
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <Button
              disabled={saving}
              loading={saving}
              label={saving ? 'Saving...' : 'Save'}
              onClick={() => {
                handleClose(modalData, isEdit);
              }}
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
